//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        id: '',
        name: '',
        description: '',
        type: '',
        // graph: '',
        // graph_draft: '',
        is_system: false,
        version: '',
        scheduler_type: '',
        enable: false,
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'blur' }],

      },
    };
  },
  computed: {
    // 只有 workflow 才显示调度类型
    schedulerTypeHidden() {
      return this.form.type !== 'workflow';
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        console.log(this.row.id);
        if (this.row.id) {
          this.$request({
            url: this.$api.getAgentAppById,
            data: {
              id: this.row.id,
            },
          }).then((res) => {
            this.form = res.agent_app;
          });
        }
      }
    },
    'form.type'(val) {
      if (val === 'ma') {
        this.form.scheduler_type = 'temporal';
      } else if (val === 'chatflow') {
        this.form.scheduler_type = 'local';
      }
      // workflow 不自动赋值，保留用户选择
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    onSubmit() {
      console.log('submit!');
    },
    openJsonEdit(key) {
      this.jsonData = this.form[key];
      this.currentJson = key;
      this.$nextTick(() => {
        this.showJson = true;
      });
    },
    saveJson(json) {
      this.form[this.currentJson] = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    handleEnableChange() {
      const newVal = !this.form.enable;
      const action = newVal ? '生效' : '取消生效';
      this.$confirm(`确认${action}该应用吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 用户确认后才更新值
          this.$set(this.form, 'enable', newVal);
        })
        .catch(() => {
          // 用户取消，不做任何操作
        });
    },
    updateAgentApp() {
      // 只提取需要的字段：description, enable, id, name, scheduler_type, type, version
      const { description, enable, id, name, scheduler_type, type, version } = this.form;
      const agentAppData = { description, enable, id, name, scheduler_type, type, version };
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // updateAgentApp
          this.$request({
            url: this.$api.updateAgentApp,
            data: {
              id: this.row.id,
              agent_app: {
                ...agentAppData,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });

      // console.log('%c Line:140 🌮 this.form', 'color:#fca650', this.form);
    },
  },
};
